import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import SubmitPage from './pages/SubmitPage';
import LoginPage from './pages/LoginPage';
import ModeratorPage from './pages/ModeratorPage';
import FeedPage from './pages/FeedPage';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<SubmitPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/moderator" element={<ModeratorPage />} />
        <Route path="/feed" element={<FeedPage />} />
      </Routes>
    </Router>
  );
}

export default App;
